import { validation } from "../constants";

export const isEmptyOrSpaces = (str: string) => {
    return str === null || str === undefined || str.trim().length === 0;
};

export const trimProvidedCharacterFromEnd = (data: string, char: string) => {
    if (data.charAt(data.length - 1) === char) {
        return data.slice(0, -1);
    }

    return data;
};
